export const isInternational = type => type === 'international';
export const isDomestic = type => type === 'domestic';
